module.exports = __webpack_public_path__ + "747e9a651a9d40da7c9e05f545058dfc.mp4";